import { DataMapping } from "../dataMapping/dataMappingApi";
import { emptyV2Api as api } from "../emptyV2Api";
import { ProductGroupUploadJob } from "./ProductGroupUploadJob";
import { ProductGroup } from "./productTypes";
export const addTagTypes = ["dataMapping", "ProductGroup"] as const;
const injectedRtkApi = api
.enhanceEndpoints({
  addTagTypes
})
.injectEndpoints({
  endpoints: (build) => ({
    getProductGroups: build.query<ProductGroup[], void>({
      query: () => ({
        url: "/products-group/get",
        method: "POST"
      }),
      providesTags: ["ProductGroup"]
    }),
    // getProductGroup: build.query<ProductGroup, string>({
    //   query: (id) => "/products-group/manage?id=" + id,
    //   providesTags: ["ProductGroup"]
    // }),
    getProductGroup: build.query<ProductGroup, string>({
      query: (id) => ({
        url: "/products-group/get",
        method: "POST",
        body: { id }
      }),
      providesTags: ["ProductGroup"]
    }),
    postProductGroup: build.mutation<ProductGroup, ProductGroup>({
      query: (pg) => ({
        url: "/products-group/manage",
        method: "POST",
        body: pg,
      }),
      invalidatesTags: ["ProductGroup"]
    }),
    putProductGroup: build.mutation<ProductGroup, ProductGroup>({
      query: (pg) => ({
        url: "/products-group/manage",
        method: "PUT",
        body: pg,
      }),
      invalidatesTags: ["ProductGroup"]
    }),
    delProductGroup: build.mutation<ProductGroup, string>({
      query: (id) => ({
        url: "/products-group/manage?id=" + id,
        method: "DELETE",
      }),
      invalidatesTags: ["ProductGroup"]
    }),
    getProductGroupUploadJobs: build.query<ProductGroupUploadJob[], void>({
      query: () => "/products-group/upload",
    }),
    getProductsById: build.query<DataMapping[], string[]>({
      query: (ids) => "/data-mapping/manage?ids=" + ids.join(","),
      providesTags: ["dataMapping"]
    }),
  })
});

export const {
  useGetProductGroupsQuery,
  useGetProductGroupQuery,
  useGetProductsByIdQuery,
  usePostProductGroupMutation,
  usePutProductGroupMutation,
  useDelProductGroupMutation,
  useGetProductGroupUploadJobsQuery
} = injectedRtkApi;